import React from 'react'
import Icon, { IconType } from '../Icon'
import styles from '@bt-react/styles'
import { Button as ReactstrapButton } from 'reactstrap'
import Props, { buttonType } from './types'
import classnames from 'classnames'
import getColorClass from '@bt-react/libs/getColorClass'
import componentStyles from './Button.module.scss'

const Button: React.FC<Props> = props => {

  const {
    block = false,
    disabled = false,
    loading = false,
    type = buttonType.button
  } = props

  const buttonClasses = classnames(
    getColorClass(props.color, 'button'),
    { [styles['btn-block']]: block },
    props.className
  )

  return <ReactstrapButton
    innerRef={props.innerRef}
    onMouseEnter={props.onMouseEnter}
    onMouseLeave={props.onMouseLeave}
    className={buttonClasses}
    style={props.style}
    data-bdd={props.dataBdd || 'button'}
    cssModule={styles}
    color={props.color}
    size={props.size}
    onClick={props.onClick}
    onKeyDown={props.onKeyDown}
    disabled={disabled}
    type={type}
    tabIndex={props.tabIndex}
    {...(props.id ? {id: props.id} : {})}
  >
    {
      loading
        ? <Icon className={classnames(componentStyles['loading-icon'], props.spinnerClassName)} name={IconType.iconName.spinner} colour={props.loadingColour || IconType.colour.darkGrey}/>
        : !props.right ? <>{props.children} {props.text}</> : <>{props.text} {props.children}</>
    }
  </ReactstrapButton>

}

export default Button
